module.exports = __webpack_public_path__ + "img/makeup_artist.cc2a62bd.png";